import getLevel from '../util/get-level';

export function getName() {
  return 'ChangeHistoryGrid';
}

export function getColumnsMetadata() {
  return {
    DateTimeUser: ['ModificationDate', 'ModifiedByUser'],
    Tool: 'Tool',
    Campaign: 'CampaignName',
    AdGroup: 'AdGroupName',
    Changes: ['EntityName', 'EntityValue', 'AttributeName', 'ChangeType', 'OldValue', 'NewValue'],
    Undo: [],
  };
}

export function getRoute({
  CampaignId,
  AdGroupId,
}) {
  const level = getLevel({
    CampaignId,
    AdGroupId,
  });

  switch (level) {
    case 'AdGroup':
      return 'customer/:customer_id/account/:account_id/campaign/:campaign_id/adgroup/:adgroup_id/changehistory';
    case 'Campaign':
      return 'customer/:customer_id/account/:account_id/campaign/:campaign_id/changehistory';
    case 'Account':
    default:
      return 'customer/:customer_id/account/:account_id/changehistory';
  }
}
